import React from 'react'
import {
  Button
} from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import EditIcon from '@material-ui/icons/Edit'
import { useTranslate } from 'ra-core'

const BulkCloneButton = (props) => {
  const translate = useTranslate()
  return (
      <Button color="primary" component={RouterLink}
      to={{
        pathname: `/${props.resource}/bulkedit/${props.selectedIds}`
      }}
      startIcon={<EditIcon />}
      >
          {translate('ra.action.edit')}
      </Button>
  )
}

BulkCloneButton.propTypes = {
  resource: PropTypes.string.isRequired,
  selectedIds: PropTypes.object.isRequired
}

export default BulkCloneButton
